import React from 'react';
import AudioConfigContext from '.';
import useAudioConfig from './Hooks/useAudioConfig';

export default function AudioConfigContextProvider({ children }: { children: React.ReactNode }) {
  const audioConfig = useAudioConfig();

  return (
    <AudioConfigContext.Provider value={audioConfig}>
      {children}
    </AudioConfigContext.Provider>
  );
}
